class QuantityTierSelector extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.quantityInput = document.getElementById(`Quantity-${this.sectionId}`);
    this.addEventListener('change', this.onTierChange.bind(this));
  }

  onTierChange(event) {
    if (!event.target.matches('.quantity-tiers__radio')) return;
    if (!this.quantityInput) return;

    const tier = parseInt(event.target.value, 10);
    this.quantityInput.value = tier;
    this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('quantity-tier-selector', QuantityTierSelector);
